import CryptoJS from 'crypto-js';


/**
 * DES 操作
 * @description
 * 加密解密
 */
export const crypto = {
  encryptByMD5(strMessage) {
    if (!strMessage) return;
    return CryptoJS.MD5(strMessage).toString();
  },
  encryptByDES(strMessage, key) {
    key = key || process.env.VUE_APP_DES_KEY;
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.DES.encrypt(strMessage, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
  decryptByDES(strMessage, key) {
    key = key || process.env.VUE_APP_DES_KEY;
    let keyHex = CryptoJS.enc.Utf8.parse(key);
    let decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(strMessage),
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
  encryptByAES(strMessage, key) {
    key = key || process.env.VUE_APP_AES_KEY;
    const keyHex = CryptoJS.enc.Hex.parse(key);
    let srcs = CryptoJS.enc.Utf8.parse(strMessage);
    var encrypted = CryptoJS.AES.encrypt(srcs, keyHex, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  /*
   * [AES 解密]
   * @param {string} strMessage 待解密内容
   * @param {string} key 密钥串
   * @returns {string} 解密后的内容
   */
  decryptByAES(strMessage, key) {
    key = key || process.env.VUE_APP_AES_KEY;
    const keyHex = CryptoJS.enc.Hex.parse(key);
    let decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(strMessage)
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  },

};
